import { type Option } from 'payload'

export enum Recommendation {
  TopPick = 'top-pick',
  Recommended = 'recommended',
  Capable = 'capable',
  NotRecommended = 'not-recommended',
}

export const recommendationLabel: Record<Recommendation, string> = {
  [Recommendation.TopPick]: 'Best',
  [Recommendation.Recommended]: 'Recommended',
  [Recommendation.Capable]: 'Capable',
  [Recommendation.NotRecommended]: 'Not Capable',
}

export const recommendationOptions: Option[] = [
  {
    label: recommendationLabel[Recommendation.TopPick],
    value: Recommendation.TopPick,
  },
  {
    label: recommendationLabel[Recommendation.Recommended],
    value: Recommendation.Recommended,
  },
  {
    label: recommendationLabel[Recommendation.Capable],
    value: Recommendation.Capable,
  },
  {
    label: recommendationLabel[Recommendation.NotRecommended],
    value: Recommendation.NotRecommended,
  },
] as const satisfies Option[]

export enum Classification {
  Primary = 'primary',
  Secondary = 'secondary',
}

const ClassificationLabel: Record<Classification, string> = {
  [Classification.Primary]: 'Primary',
  [Classification.Secondary]: 'Secondary',
}

export const classificationOptions: Option[] = [
  {
    label: ClassificationLabel[Classification.Primary],
    value: Classification.Primary,
  },
  {
    label: ClassificationLabel[Classification.Secondary],
    value: Classification.Secondary,
  },
] as const satisfies Option[]

export enum RankDeltaDirection {
  Up = 'up',
  Down = 'down',
}

export const rankDeltaDirectionOptions: Option[] = [
  { label: 'Up', value: RankDeltaDirection.Up },
  { label: 'Down', value: RankDeltaDirection.Down },
] as const satisfies Option[]

export const RECOMMENDATION_SORT_ORDER: Record<Recommendation, number> = {
  [Recommendation.TopPick]: 0,
  [Recommendation.Recommended]: 1,
  [Recommendation.Capable]: 2,
  [Recommendation.NotRecommended]: 3,
}

export const CLASSIFICATION_SORT_ORDER: Record<Classification, number> = {
  [Classification.Primary]: 0,
  [Classification.Secondary]: 1,
}
